import { getAddressGeoType } from "./addressGeoHierarchy";
import { fetchGeoPlaces } from "./fetchGeoPlaces";
import { AddressGeoToken, GeoPlaceOption } from "./types";

export const findGeoPlaceByName = async (
  token: AddressGeoToken,
  name?: string,
  parentId?: string,
): Promise<GeoPlaceOption | null> => {
  const trimmed = name?.trim();

  if (!trimmed) {
    return null;
  }

  try {
    const { items } = await fetchGeoPlaces({
      type: getAddressGeoType(token),
      ...(parentId ? { parentId } : {}),
      name: trimmed,
      count: 100,
    });

    return (
      items.find((item) => item.name === trimmed) ??
      items.find((item) => item.name.toLowerCase() === trimmed.toLowerCase()) ??
      null
    );
  } catch {
    return null;
  }
};
